import * as React from "react";
const HumanIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#252835"
      strokeWidth={1.5}
      d="M8.806 6.444a3.694 3.694 0 1 1 7.388 0 3.694 3.694 0 0 1-7.388 0ZM4.658 15.27a4.806 4.806 0 0 1 3.398-1.408h8.888a4.806 4.806 0 0 1 4.806 4.806 2.584 2.584 0 0 1-2.583 2.583H5.833a2.584 2.584 0 0 1-2.583-2.583c0-1.275.506-2.497 1.408-3.398Z"
    />
  </svg>
);
export default HumanIcon;
